
export const PROSEAT_SLUG = "proseat";